import BreakdownModal from './BreakdownModal';

export default BreakdownModal;

export { BreakdownModalShell } from './BreakdownModal';
export type {
  IBreakdownCardContext,
  IBreakdownHeadline,
  IBreakdownModalProps
} from './BreakdownModal';
